import { createUseStyles, Styles } from 'react-jss';

export default createUseStyles((theme: Styles) => ({
  body: {
    padding: '15px 0',
    width: '50%'
  }
}));
